<backbone>
  <section header-page="topbar" class="d-flex justify-content-between gap-2 h-100 position-relative">
    <div class="d-flex justify-content-start align-items-center text-truncate">
      <p class="m-0 fw-medium text-truncate">Marcos, folios y reversos</p>
    </div>

    <div class="d-flex justify-content-end align-items-center gap-3">
      <breadcrumb [items]="[{ label: 'Registro Civil' }, { label: 'Marcos, folios y reversos' }]" />
    </div>
  </section>

  <section wrapper>
    <div [formGroup]="formUpload" class="page-section card">
      <div class="card-header d-flex justify-content-between align-items-center">
        <label>Subida de actas de nacimiento.</label>
        <p-button label="Procesar" [loading]="isUploading" (onClick)="upload()" [disabled]="this.files.controls.length === 0" />
      </div>
      <div class="card-body d-flex flex-column gap-3">
        <div class="d-flex flex-column flex-sm-row gap-2 gap-sm-4">
          <div class="d-flex align-items-center gap-2">
            <p-toggleswitch formControlName="marcosChecked" inputId="marcosChecked" class="d-flex" />
            <label for="marcosChecked" role="button">Agregar marcos</label>
          </div>
          <div class="d-flex align-items-center gap-2">
            <p-toggleswitch formControlName="foliosChecked" inputId="foliosChecked" class="d-flex" />
            <label for="foliosChecked" role="button">Agregar folio</label>
          </div>
          <div class="d-flex align-items-center gap-2">
            <p-toggleswitch formControlName="reversosChecked" inputId="reversosChecked" class="d-flex" />
            <label for="reversosChecked" role="button">Agregar reverso</label>
          </div>
        </div>

        <form id="upload">
          <p class="m-auto position-absolute start-0 end-0 bottom-0 top-0 d-flex flex-column justify-content-center align-items-center fs-4 fw-normal opacity-50">Da click o arrastra los archivos</p>
          <input (change)="onInputFileChanged($event)" type="file" class="form-control" accept=".pdf" multiple />
        </form>

        <div class="d-flex flex-wrap gap-3">
          @for (item of files.controls; track item; let index = $index) {
          <div formArrayName="files">
            <div class="card h-100 border-0" [ngClass]="{ 'text-bg-light': getFilesAsIndex(index)?.errors === null, 'text-bg-danger text-white': getFilesAsIndex(index)?.errors !== null }">
              <div class="card-body d-flex align-items-center gap-3">
                <p class="m-0">
                  {{ item.value.file.name }}
                  @if (getFilesAsIndex(index)?.hasError('requiredFileSize')) {
                  <small class="d-block">El tamaño del archivo no debe ser mayor a 2mb.</small>
                  } @if (getFilesAsIndex(index)?.hasError('requiredFileType')) {
                  <small class="d-block">No es un archivo válido.</small>
                  }
                </p>

                <p-button icon="pi pi-trash" severity="danger" (click)="removeFile(index)"></p-button>
              </div>
            </div>
          </div>
          }
        </div>
      </div>
    </div>

    <div class="page-section card">
      <div class="card-body p-0">
        <p-table
          #dt1
          [value]="this.list"
          [rows]="25"
          [showCurrentPageReport]="true"
          [rowsPerPageOptions]="[25, 50, 100]"
          [paginator]="true"
          [globalFilterFields]="['curp', 'identificadorElectronico']"
        >
          <ng-template pTemplate="caption">
            <div class="d-flex align-items-stretch justify-content-between gap-2">
              <p-inputgroup>
                <p-iconfield class="w-100">
                  <p-inputicon styleClass="pi pi-search" />
                  <input
                    type="text"
                    pInputText
                    [(ngModel)]="searchValue"
                    (input)="dt1.filterGlobal(searchValue, 'contains')"
                    placeholder="Buscar por CURP o identificador electrónico."
                    class="w-100 h-50px rounded-end-0"
                  />
                </p-iconfield>
                <p-inputgroup-addon *ngIf="searchValue" pTooltip="Limpiar busqueda">
                  <p-button icon="pi pi-times" severity="secondary" class="h-100" styleClass="h-100" (click)="searchValue = ''; dt1.filterGlobal(searchValue, 'contains')" />
                </p-inputgroup-addon>
              </p-inputgroup>
            </div>
          </ng-template>

          <ng-template pTemplate="header">
            <tr>
              <th>TIPO</th>
              <th>CURP</th>
              <th>IDENTIFICADOR ELECTRONICO</th>
              <th colspan="2">FECHA</th>
            </tr>
          </ng-template>

          <ng-template pTemplate="body" let-item>
            <tr>
              <td class="text-nowrap">{{ item.type }}</td>
              <td class="text-nowrap">{{ item.curp }}</td>
              <td class="text-nowrap">{{ item.identificadorElectronico }}</td>
              <td class="text-nowrap">{{ item.dateCreated | date : "longDate" }}</td>
              <td class="text-nowrap text-end">
                @if (item.download === 0) {
                <a
                  href="{{ apiUrl }}/v1/registro-civil/marco-folio-reverso/download/{{ item.id }}"
                  download
                  target="_blank"
                  rel="noopener noreferrer"
                  class="p-button text-decoration-none p-button-success"
                  (click)="item.download = 1"
                >
                  <i class="pi pi-download"></i>
                </a>
                } @else {
                <a href="{{ apiUrl }}/v1/registro-civil/marco-folio-reverso/download/{{ item.id }}" download target="_blank" rel="noopener noreferrer" class="p-button text-decoration-none">
                  <i class="pi pi-download"></i>
                </a>
                }
              </td>
            </tr>
          </ng-template>

          <ng-template pTemplate="emptymessage">
            <tr>
              <td [attr.colspan]="6">No se encontraron registros.</td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </section>
</backbone>
